import React from 'react';

const ScoreCardForReading = (props) => {
    const colorClass = props.score === 1 ? 'text-green-500' : 'text-red-500';

  return (
    <div className={`flex items-center justify-center h-48 w-48 rounded-full border-8 border-purple-800 ${colorClass} text-4xl font-semibold`}>
      {props.score}/{props.maxScore}
    </div>
  );
};

export default ScoreCardForReading;
